var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from "vue-property-decorator";
import axios from "axios";
class Workflow {
    id = undefined;
    name = "";
    description = "";
    control = false;
    date;
    time;
    worktype = "";
}
class assignment {
    id = undefined;
    material = "";
    thickness = "";
    format = "";
    quantity = "";
}
class job {
    article = "";
    customer = "";
    date = "";
    index = "";
    note = "";
    quantity_per_piece = "";
    time = "";
    order_nr = "";
    final_control = false;
}
let EditJob = class EditJob extends Vue {
    id = this.$route.params.id;
    diaWork = false;
    e1 = 1;
    job = new job;
    workstep = {};
    assignments = [];
    assignment = new assignment();
    material = [];
    thickness = [];
    format = [];
    worktype = [];
    worklogs = [];
    workflow = new Workflow();
    count = 0;
    dia = false;
    text = '';
    snackbar = false;
    timeout = 5000;
    color = "#F44336";
    headers = [
        { text: 'Format', value: 'format' },
        { text: 'Material', value: 'material' },
        { text: 'Dicke', value: 'thickness' },
        { text: 'Anzahl', value: 'quantity' },
        { text: 'Aktionen', value: 'actions' },
    ];
    worklogheader = [
        { text: 'Ausführender', value: 'name' },
        { text: 'Kontrolle', value: 'control' },
        { text: 'Arbeitschritt', value: 'work_type' },
        { text: 'Beschreibung', value: 'description' },
        { text: 'Datum', value: 'date' },
        // {text: 'Zeit', value: 'time'},
        { text: 'Aktionen', value: 'actions' },
    ];
    create() {
        axios.put('/api/jobs/' + this.id, {
            job: this.job,
            assignments: this.assignments,
            worklogs: this.worklogs,
            id: this.id
        }).then((response) => {
            if (response.status == 201) {
                this.$router.push('/job');
            }
        }).catch((error) => {
            Object["values"](error.response.data.errors).forEach(value => {
                if (value.isArray === true) {
                    value.forEach(function (msg) {
                        error = error + " \n " + msg;
                    });
                }
                else {
                    error = error + " \n " + value;
                }
            });
            this.text = error;
            this.snackbar = true;
        });
        this.snackbar = false;
    }
    F;
    mounted() {
        if (this.$store.getters.isLoggedIn) {
            this.getMaterial();
            this.getThickness();
            this.getFormat();
            this.getWorktype();
            this.getWorklog();
            this.getjobs();
            this.getAssigemnts();
            this.getWorkflow();
            this.$store.state.monitor = false;
        }
        else {
            this.$store.commit('logout');
        }
    }
    getMaterial() {
        axios.get('/api/material').then((response) => {
            this.material = response.data.data;
        });
        return this.material;
    }
    getThickness() {
        axios.get('/api/thickness').then((response) => {
            this.thickness = response.data.data;
        });
        return this.thickness;
    }
    assigmentDelete(item) {
        if (confirm("Do you really want to delete?")) {
            let index = this.assignments.indexOf(item);
            if (index >= 0) {
                this.assignments.splice(index, 1);
                this.text = "Der Materialbedarf wurde erfolgreich gelöscht";
                this.color = "green";
                this.snackbar = true;
            }
            this.snackbar = false;
        }
    }
    worklogDelete(item) {
        if (confirm("Do you really want to delete?")) {
            let index = this.worklogs.indexOf(item);
            if (index >= 0) {
                this.worklogs.splice(index, 1);
                this.text = "Der Arbeitsschritt wurde erfolgreich gelöscht";
                this.color = "green";
                this.snackbar = true;
            }
            this.snackbar = false;
        }
    }
    getFormat() {
        axios.get('/api/format').then((response) => {
            this.format = response.data.data;
        });
        return this.format;
    }
    getWorktype() {
        axios.get('/api/worktype').then((response) => {
            this.worktype = response.data.data;
        });
        return this.worktype;
    }
    getjobs() {
        axios.get('/api/jobs/' + this.id).then((response) => {
            this.job = response.data.data;
        });
        return this.job;
    }
    getAssigemnts() {
        axios.get('/api/assigment/' + this.id + '/job').then((response) => {
            this.assignments = response.data.data;
        });
        return this.assignments;
    }
    getWorkflow() {
        axios.get('/api/worklog/' + this.id + '/job').then((response) => {
            this.worklogs = response.data.data;
        });
        return this.worklogs;
    }
    getWorklog() {
        axios.get('/api/worklog/empty').then((response) => {
            this.worklogs = response.data.data;
        });
        return this.worklogs;
    }
    sendWorkflow() {
        if (this.workflow.id == null) {
            this.worklogs.push(this.workflow);
        }
        else {
            this.worklogs[this.workflow.id];
        }
        this.workflow = new Workflow();
        this.diaWork = false;
    }
    sendAssignments() {
        if (this.assignment.id == null) {
            this.assignments.push(this.assignment);
        }
        else {
            this.assignments[this.assignment.id];
        }
        this.assignment = new assignment();
        this.dia = false;
    }
    assigmentedit(item) {
        let index = this.assignments.indexOf(item);
        if (index >= 0) {
            this.assignment = this.assignments[index];
            this.assignment.id = index.toString();
            //this.worklogs.splice(index, 1);
            this.dia = true;
        }
    }
    worklogsedit(item) {
        let index = this.worklogs.indexOf(item);
        if (index >= 0) {
            this.workflow = this.worklogs[index];
            this.workflow.id = index.toString();
            //this.worklogs.splice(index, 1);
            this.diaWork = true;
        }
    }
    arrayRemove(arr, value) {
        return arr.filter(function (ele) {
            return ele != value;
        });
    }
    checkOrderNumber() {
        axios.get('/api/jobs/order/' + this.job.order_nr).then((response) => {
            if (response.status == 201) {
                this.text = this.job.order_nr + " Die Bestellnummer ist schon vergeben";
                this.color = "#F44336";
                this.snackbar = true;
            }
        }).catch((error) => {
            // this.text = this.job.order_nr + " Die Bestellnummer ist Verfügbar";
            // this.color="green";
            this.snackbar = false;
        });
        this.snackbar = false;
    }
    diaclose() {
        this.dia = false;
        this.diaWork = false;
    }
};
EditJob = __decorate([
    Component({
        name: "EditJob",
    })
], EditJob);
export default EditJob;
